import React from "react";
import { useTranslation } from "react-i18next";

interface ErrorNotificationProps {
    message: string;
}

const ErrorNotification: React.FC<ErrorNotificationProps> = () => {
    const { t } = useTranslation();

    return (
        <div
            className="error_noti"
            style={{
                marginTop: 28,
                marginBottom: 45,
                marginLeft: 20,
                marginRight: 20,
            }}
        >
            <div className="page_not_found error_message">
                <div className="inner">
                    <p> {t("pageNotFound")} </p>
                </div>
            </div>
        </div>
    );
};

export default ErrorNotification;
